import React from 'react'
import { withRouter } from 'react-router-dom';
import MenuBar from './MenuBar'
import withAuthentication from './identity/withAuthentication';

import { auth } from '../firebase';
import * as api from '../api'
import * as routes from '../config/routes';


class AdminOnly extends React.Component {
  state = {
    user: {}
  }

  componentDidMount() {
    if (auth.currentUser()){
      api.makeApiPost(routes.API_GET_USER, {uid: auth.currentUser().uid}, (res) => {
      	if (res.user) 
	        this.setState({user: res.user})
      })
    }
  }

  render() {
    return (
      <div>
        <MenuBar />
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m4">
              {(this.state.user.role 
              	=== 'admin' ? (<p>Yayy! Admin</p>) : false)}
              {(this.state.user.role 
              	=== 'user' ? (<p>Yayy! User</p>) : false)}
          	  </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withAuthentication(AdminOnly));



// WEBPACK FOOTER //
// ./src/components/AdminOnly.js